<template>
  <b-row>
    <!-- Resumo Real do Evento -->
    <b-col cols="12" v-if="form.id && form.temCobranca" class="mb-2">
       <h5 class="mb-1">Saúde Financeira Real (Arrecadação)</h5>
       <financial-summary-card :summary="globalSummary" v-if="globalSummary" />
    </b-col>

    <b-col cols="12">
      <b-card border-variant="primary" class="shadow-none">
        <b-row>
          <b-col cols="12" md="6">
            <b-form-group label="O evento possui cobrança?">
              <b-form-checkbox v-model="form.temCobranca" switch inline>
                {{ form.temCobranca ? 'Sim' : 'Não' }}
              </b-form-checkbox>
            </b-form-group>
          </b-col>
        </b-row>

        <b-row v-if="form.temCobranca">
          <b-col cols="12" md="4">
            <b-form-group label="Valor da Inscrição">
              <money v-model="form.valor" v-bind="moneyConfig" class="form-control" />
            </b-form-group>
          </b-col>
          <b-col cols="12" md="4">
            <b-form-group label="Conta para Recebimento">
              <v-select v-model="form.conta.id" :reduce="i => i.id" label="descricao" :options="comboContas" />
            </b-form-group>
          </b-col>
          <b-col cols="12" md="4">
            <b-form-group label="Classificação Financeira">
              <v-select v-model="form.tipoPagamentoRecebimento.id" :reduce="i => i.id" label="descricao" :options="comboTipoPagamento" />
            </b-form-group>
          </b-col>
        </b-row>

        <!-- Detalhes de Recorrência (Baseado no Tipo de Evento) -->
        <b-row v-if="form.tipoEvento && form.tipoEvento.recorrente" class="mt-1">
          <b-col cols="12">
            <div class="alert alert-info py-50 mb-0">
              <small>
                <strong>Evento Recorrente:</strong> Este tipo de evento gera mensalidades automáticas.
                <span v-if="form.tipoEvento.temProRata" class="ml-1">
                  <feather-icon icon="CheckIcon" size="12" /> Cálculo de Pro-rata Ativo
                </span>
                <span class="ml-1">Vencimento: Dia {{ form.tipoEvento.diaVencimentoPadrao }}</span>
              </small>
            </div>
          </b-col>
        </b-row>
      </b-card>
    </b-col>

    <!-- Seção do Simulador (Só aparece se tiver custos lançados ou for edição) -->
    <b-col cols="12" v-if="form.id && form.temCobranca">
      <b-card title="Simulador de Preço / Break-even" border-variant="info" class="shadow-none">
        <b-row class="align-items-center">
          <b-col cols="12" md="8">
            <p class="text-muted">
              Baseado nos custos lançados e na maior taxa de gateway configurada para o tipo de evento,
              o sistema sugere o valor ideal para que não haja prejuízo.
            </p>
          </b-col>
          <b-col cols="12" md="4" class="text-right">
            <b-button variant="info" size="sm" @click="simular">
              <feather-icon icon="CalculatorIcon" class="mr-50" />
              Calcular Sugestão
            </b-button>
          </b-col>
        </b-row>

        <b-row v-if="simulacao" class="mt-2">
          <b-col cols="6" md="3">
            <div class="text-center p-1 border rounded bg-light">
              <small class="text-muted d-block">Custo Total</small>
              <strong class="text-danger">R$ {{ simulacao.totalCustos.toFixed(2) }}</strong>
            </div>
          </b-col>
          <b-col cols="6" md="3">
            <div class="text-center p-1 border rounded bg-light">
              <small class="text-muted d-block">Custo p/ Pessoa</small>
              <strong>R$ {{ simulacao.custoPerCapita.toFixed(2) }}</strong>
            </div>
          </b-col>
          <b-col cols="6" md="3">
            <div class="text-center p-1 border rounded bg-success text-white">
              <small class="d-block">Preço Sugerido</small>
              <strong>R$ {{ simulacao.precoSugerido.toFixed(2) }}</strong>
            </div>
          </b-col>
          <b-col cols="6" md="3">
            <div class="text-center p-1 border rounded bg-light">
              <small class="text-muted d-block">Taxa Gateway (Máx)</small>
              <strong class="text-warning">{{ simulacao.maiorTaxaGateway.toFixed(2) }}%</strong>
            </div>
          </b-col>
        </b-row>
      </b-card>
    </b-col>
  </b-row>
</template>

<script>
import { BRow, BCol, BCard, BFormGroup, BFormCheckbox, BButton } from 'bootstrap-vue'
import { Money } from 'v-money'
import vSelect from 'vue-select'
import { mapState } from 'vuex'
import eventService from '@/api/eventModule/eventServices'
import FinancialSummaryCard from '../components/FinancialSummaryCard.vue'

export default {
  components: { BRow, BCol, BCard, BFormGroup, BFormCheckbox, BButton, Money, vSelect, FinancialSummaryCard },
  props: ['form', 'isEdit'],
  data() {
    return {
      simulacao: null,
      globalSummary: null,
      moneyConfig: {
        decimal: ',', thousands: '.', prefix: 'R$ ', precision: 2, masked: false
      },
      comboContas: [], // Carregar via API
      comboTipoPagamento: [] // Carregar via API
    }
  },
  async mounted() {
    if (this.form.id) {
      this.fetchGlobalSummary()
    }
    // Carregar combos necessários
    // this.comboContas = await ...
    // this.comboTipoPagamento = await ...
  },
  methods: {
    async simular() {
      try {
        const res = await eventService.simularPreco(this.form.id)
        this.simulacao = res.data
      } catch (e) {
        console.error(e)
      }
    },
    async fetchGlobalSummary() {
      try {
        const { data } = await this.$http.get(`/evento/eventos/${this.form.id}/financeiro`)
        this.globalSummary = data
      } catch (error) {
        console.error('Erro ao buscar resumo financeiro:', error)
      }
    }
  }
}
</script>
